// import MySuperComponent from "./Components/MySuperComponent";

export default {
  // Add your own components here to render new content types
  // "magento-content-type-name": MySuperComponent
};
